export default function initMultiSwitchers() {
	var sections = document.querySelectorAll("[data-switcher]");
	var triggers = document.querySelectorAll("[data-switcher-trigger]");
	if (sections.length > 0 && triggers.length > 0) {
		multiSwitcher(triggers, sections);
	}
}

/*
	Takes triggers and targets - both which require data-type attributes.
	When a $trigger is clicked it adds/removes 'is-active' class to each $target if
	it's type matches the clicked $trigger type.
 */

function multiSwitcher(triggers, targets) {
	triggers.forEach(trigger => {
		trigger.addEventListener("click", e => {
			var newType = trigger.dataset.type;
			targets.forEach(target => {
				if (target.dataset.type && target.dataset.type === newType) {
					target.classList.add("is-active");
				} else {
					target.classList.remove("is-active");
				}
			});

			triggers.forEach(trigger => {
				trigger.classList.remove("is-active");
			});
			trigger.classList.add("is-active");

			e.preventDefault();
		});
	});
}
